import { tmrCartViewAddProducts } from 'kanzler.my-target';
import { Vuex } from 'ui.vue.vuex';

export const MAX_BASKET_QUANTITY = 9;
export const MAX_SUM = 500000;

export const store = Vuex.store({
	strict: true,
	state: {
		items: [],
		totals: {
			sumFormatted: '',
			discountPercentFormatted: '',
			discountSum: 0,
		},
		configuration: {
			ajaxUrl: '',
			pathToBasket: '',
			actionVariable: '',
			siteId: '',
			siteTemplateId: '',
			template: '',
			signedParamsString: '',
		}
	},
	mutations: {
		replaceItems(state, items) {
			state.items = items;
		},
		configure(state, configuration) {
			state.configuration = configuration;
		},
		setTotals(state, totals) {
			state.totals = totals;
		}
	},
	actions: {
		replaceItems({ commit, state: { configuration: { pathToBasket } } }, items) {
			if (items.length > 0) {
				commit("replaceItems", items);
			} else {
				document.location.href = pathToBasket;
			}
		},
		updateItemQuantity({ dispatch, getters: { nextTotalQuantity, item }, state: { configuration } }, { id, quantity }){
			const tmrEvent = item(id).quantity > quantity
				? 'tmrProductRemove'
				: 'tmrProductAdd';

			recalculateBasket(
				{
					basket:
						quantity > 0
							? { [`QUANTITY_${id}`]: quantity }
							: { [`DELETE_${id}`]: "Y" },
				},
				configuration
			).then((response) => dispatch(
				"commitBasketResult",
				response.BASKET_DATA
			)).then(() => dispatch(
				tmrEvent, { id, quantity: Math.abs(quantity - item(id).quantity) }
			));
		},
		refreshBasket({ dispatch, state: { configuration } }) {
			recalculateBasket(
				{},
				configuration
			).then((response) => dispatch(
				"commitBasketResult",
				response.BASKET_DATA
			));
		},
		tmrProductRemove({ getters: { item, items } }, { id, quantity }) {
			return Promise.all([
				tmrCartViewAddProducts(items).then((impression) => {
					console.log('tmrProductRemove' + impression);
					window._tmr.push(impression);
				})
			]);
		},
		tmrProductAdd({ getters: { item, items } }, { id }) {
			return Promise.all([
				tmrCartViewAddProducts(items).then((impression) => {
					console.log('tmrProductAdd' + impression);
					window._tmr.push(impression);
				})
			]);
		},
		commitBasketResult({ commit }, basketResult) {
			commit('setTotals', fromBasketResponse(basketResult));
			commit('replaceItems', Object.values(basketResult.GRID.ROWS).map(fromBasketItem));

			const basketAllQuantity = Object.values(basketResult.GRID.ROWS)?.length || 0;
			if ($('.top_line_cart_block')?.length) {
				$('.top_line_cart_block > a > p').text(basketAllQuantity);
			}

			setProductListMindbox(basketResult?.MINDBOX_DATA);
		},
	},
	getters: {
		totals: (state) => state.totals,
		items: (state) => state.items,
		item: (_, { items }) => (itemId) => items.find(({ id }) => id === itemId),
		maxSum: () => MAX_SUM,
		isQuantityOverflowed: (_, { items }) => {
			return items.reduce((totalQuantity, item) => totalQuantity + Number(item.quantity), 0) > MAX_BASKET_QUANTITY;
		},
		isSumOverflowed: (_, { totals }) => {
			return totals.sum > MAX_SUM;
		},
		nextTotalQuantity: (_, { items }) => {
			return (itemId, nextItemQuantity) => {
				return items.reduce((totalQuantity, item) => {
					if (item.id === itemId) {
						return totalQuantity + Number(nextItemQuantity);
					}
					return totalQuantity + Number(item.quantity);
				}, 0);
			}
		},
		itemPreviewImage: (_, { item }) =>
			(itemId) => {
				const basketItem = item(itemId);
				return basketItem.imageLink
					? basketItem.imageLink
					: (typeof basketItem.images !== 'undefined' && basketItem.images.length > 0)
						? basketItem.images[0].IMAGE_SRC
						: ''
			},
		itemPreviewImage2x: (_, { item }) =>
			(itemId) => {
				const basketItem = item(itemId);
				return basketItem.imageLink
					? basketItem.imageLink
					: (typeof basketItem.images !== 'undefined' && basketItem.images.length > 0)
						? basketItem.images[0].IMAGE_SRC_2X
						: ''
			},
	},
});

export function fromBasketResponse(basketResponse) {
	return {
		sum: basketResponse.allSum,
		sumFormatted: basketResponse.allSum_FORMATED,
		basePrice: basketResponse.BASE_PRICE,
		basePriceFormatted: basketResponse.BASE_PRICE_FORMATTED,
		discountPercentFormatted: basketResponse.DISCOUNT_PERCENT_FORMATTED,
		discountSum: basketResponse.DISCOUNT_PRICE_ALL,
		discountSumFormatted: basketResponse.DISCOUNT_PRICE_ALL_FORMATED,
	}
}

export function fromBasketItem(rawBasketItem) {
	return {
		id: rawBasketItem.ID,
		productId: rawBasketItem.PRODUCT_ID,
		name: rawBasketItem.NAME,
		catalogLink: rawBasketItem.DETAIL_PAGE_URL,
		imageLink: rawBasketItem.DETAIL_PICTURE_SRC,
		quantity: rawBasketItem.QUANTITY,
		availableQuantity: Number(rawBasketItem.AVAILABLE_QUANTITY),
		priceFormatted: rawBasketItem.PRICE_FORMATED,
		price: rawBasketItem.PRICE,
		oldPriceFormatted: rawBasketItem.DISCOUNT_PRICE_PERCENT > 0 ? rawBasketItem.FULL_PRICE_FORMATED : undefined,
		oldPrice: rawBasketItem.DISCOUNT_PRICE_PERCENT > 0 ? rawBasketItem.FULL_PRICE : undefined,
		discountValueFormatted: rawBasketItem.DISCOUNT_PRICE_PERCENT_FORMATED,
		images: rawBasketItem.PROPERTY_MORE_PHOTO_VALUE_SRC,
		basketProperties: Object.values(rawBasketItem.PROPS).reduce((accumulator, value) => {
			accumulator[value.NAME] = value.VALUE;
			return accumulator;
		}, {}),
	}
}

export function fromOrder(rawOrderBasketItem) {
	return {
		id: rawOrderBasketItem.data.ID,
		productId: rawOrderBasketItem.data.PRODUCT_ID,
		name: rawOrderBasketItem.data.NAME,
		catalogLink: rawOrderBasketItem.data.DETAIL_PAGE_URL,
		imageLink: rawOrderBasketItem.data.DETAIL_PICTURE_SRC,
		quantity: rawOrderBasketItem.data.QUANTITY,
		availableQuantity: undefined,
		priceFormatted: rawOrderBasketItem.data.PRICE_FORMATED,
		price: rawOrderBasketItem.data.PRICE,
		oldPriceFormatted: rawOrderBasketItem.data.DISCOUNT_PRICE_PERCENT > 0 ? rawOrderBasketItem.data.BASE_PRICE_FORMATED : undefined,
		oldPrice: rawOrderBasketItem.data.DISCOUNT_PRICE_PERCENT > 0 ? rawOrderBasketItem.data.BASE_PRICE : undefined,
		discountValueFormatted: rawOrderBasketItem.data.DISCOUNT_PRICE_PERCENT_FORMATED,
		images: [],
		basketProperties: Object.values(rawOrderBasketItem.data.PROPS).reduce((accumulator, value) => {
			accumulator[value.NAME] = value.VALUE;
			return accumulator;
		}, {}),
	}
}

function recalculateBasket(data, configuration) {
	return fetch(
		configuration.ajaxUrl,
		{
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'X-Bitrix-Csrf-Token': BX.bitrix_sessid(),
			},
			body: $.param({
				...data,
				[configuration.actionVariable]: 'recalculateAjax',
				via_ajax: 'Y',
				site_id: configuration.siteId,
				site_template_id: configuration.siteTemplateId,
				template: configuration.template,
				signedParamsString: configuration.signedParamsString,
			}),
		}
	)
	.then((response) => response.json())
}
